import React from 'react';

import image01Png from '../../../assets/images/technology/graph/technology-graph-01.png';
// import image01 from '../../../assets/images/technology/graph/technology-graph-01.svg';
// import image02 from '../../../assets/images/technology/graph/technology-graph-02.svg';
import image02Png from '../../../assets/images/technology/graph/technology-graph-02.png';
import image03Png from '../../../assets/images/technology/graph/technology-graph-03.png';
import image04 from '../../../assets/images/technology/graph/technology-graph-04.svg';
import image05 from '../../../assets/images/technology/graph/technology-graph-05.svg';
import image06 from '../../../assets/images/technology/graph/technology-graph-06.svg';

export const graphStatic = [
  {
    image: {
      src: image01Png,
      alt: 'Source of pollutants - Mila stats',
      width: 604,
      height: 375,
      caption: <>
        The primary issue affecting your indoor air quality last month was elevated levels of indoor particulate matter (PM). Yuck!
               </>,
    },
    title: 'Track your home’s pollutants',
    description: () => (
      <p>
        Get a complete view of the quantity and sources of pollutants in your home.
      </p>
    ),
  },
  {
    image: {
      src: image02Png,
      alt: 'Tells you your exposure risk - Mila stats',
      width: 604,
      height: 379,
      caption: <>
        Two days this month were excessively
        <br />
        humid and at risk of mold. 😷
      </>,
    },
    title: 'Warns you of mold risk',
    description: () => (
      <p>See when humidity levels rise to create conditions that put your air, and your health, at risk.</p>
    ),
  },
  {
    image: {
      src: image03Png,
      alt: 'Monitor outdoor air quality - Mila stats',
      width: 604,
      height: 378,
      caption: <>
        Your Milas improved your indoor air quality by 76%.
        <br />
        Not too shabby. 😌
      </>,
    },
    title: 'Get your filtered air breakdown',
    description: () => (
      <p>Learn how much Mila improved your air quality, quantified in how many micrograms of pollutants were filtered out.</p>
    ),
  },
  {
    image: {
      src: image04,
      alt: 'Mila’s health impact - Mila stats',
      width: 576,
      height: 373,
      caption: 'You had 14 days when the AQI went over 50. That’s icky.',
    },
    title: 'Monitor outdoor air quality',
    description: () => (
      <p>Stay a step ahead of what’s blowing in from outside.</p>
    ),
  },
  {
    image: {
      src: image05,
      alt: 'See daily trends - Mila stats',
      width: 576,
      height: 333,
      caption: 'Your AQI tends to increase 30% around 11:30 a.m. in your living room.',
    },
    title: 'See daily trends',
    description: () => (
      <p>
        Track how your air shifts throughout the day, from morning to midnight.
      </p>
    ),
  },
  {
    image: {
      src: image06,
      alt: 'Compare your air - Mila stats',

      width: 577,
      height: 327,
      caption: <>
        Your average AQI ranks in the top 55% of all
        <br />
        {' '}
        Miliebers around the world.
      </>,
    },
    title: 'Compare your air',

    description: () => (
      <p>
        See how your air stacks up against
        <br />
        other Mila homes.
      </p>
    ),
  },
];
